export default function ResultadosTotales(params){
    const coleccion = params.coleccion;
    let var_ingles = "es";
    if (window.location.href.indexOf("en.") > -1) {
        var_ingles = "en."
    }
    const Result_Mensaje = (() => {     
        let mensaje = var_ingles ==="es"? "Resultados: ": "Results: ";
        return mensaje;
    });
    return(
        <div className="col-lg-3" id="ResultadosTotales" style={{display:"none"}} aria-live="assertive" aria-atomic="true" aria-relevant="all">
            <div style={{float:"right"}}>
                <span className="text-primary"> {Result_Mensaje()}  
                </span>
                <span id="resultados" className="badge bg-sd-gray-150 rounded-pill fw-bolder">0
                </span>
            </div>
        </div>
    )
}

